import { inject, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DashboardStatsService } from '../../../services/dashboardStats.service';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { DashboardStats } from '../../../shared/models/dashboard-stats.model';
import { SkeletonModule } from 'primeng/skeleton';
import { DynamicTextPipe } from '../../../core/pipes/dynamic-text.pipe';

@Component({
  selector: 'app-dashboard-stats',
  standalone: true,
  imports: [
    CommonModule,
    SelectModule,
    TableModule,
    ButtonModule,
    TextareaModule,
    InputTextModule,
    DatePickerModule,
    SkeletonModule,
    DynamicTextPipe
  ],
  templateUrl: './dashboard-stats.component.html',
  styleUrl: './dashboard-stats.component.scss'
})
export class DashboardStatsComponent implements OnInit {
  private dashboardStatsService = inject(DashboardStatsService);
  private router = inject(Router);
  stats: DashboardStats = {} as DashboardStats;
  isLoading = false;

  ngOnInit() {
    this.isLoading = true;
    this.dashboardStatsService.getDashboardStats().subscribe({
      next: (data) => {
        this.stats = data.data;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching dashboard stats:', error);
        this.isLoading = false;
      }
    });
  }

  hasWarnings(): boolean {
    return (
      this.stats.serviceAuthorizationExpiredPatients > 0 ||
      this.stats.patientsServiceAuthorizationWillExpireWithinAWeek > 0 ||
      this.stats.expiredCaregiverCertificateCount > 0
    );
  }

  navigateToExpiredPatients(): void {
    this.router.navigate(['/patient'], {
      queryParams: { expiredFilter: 'Expired' }
    });
  }

  navigateToExpiredCaregiverCertificates(): void {
    this.router.navigate(['/caregiver']);
  }
}
